import React, { useState, useEffect } from "react";
import {
  Button,
  Menu,
  Layout,
  Typography,
  Row,
  Col,
  Space,
  Drawer,
} from "antd";
import {
  QrcodeOutlined,
  DownOutlined,
  MenuOutlined,
  LoginOutlined,
  UserOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;
const { Title, Paragraph } = Typography;

const HeaderLayout = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = (
    <>
      <Menu.SubMenu
        title={<span>Convert PDF {!isMobile && <DownOutlined />}</span>}
      >
        <Menu.Item onClick={() => navigate("/word2pdf")}>Word to PDF</Menu.Item>
        <Menu.Item onClick={() => navigate("/excel2pdf")}>
          Excel to PDF
        </Menu.Item>
        <Menu.Item onClick={() => navigate("/ppt2pdf")}>
          PowerPoint to PDF
        </Menu.Item>
        <Menu.Item onClick={() => navigate("/image2pdf")}>
          Image to PDF
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.SubMenu
        title={<Space>Generate QR {!isMobile && <DownOutlined />}</Space>}
      >
        <Menu.Item onClick={() => navigate("/qr-link")}>Link to QR</Menu.Item>
        <Menu.Item onClick={() => navigate("/qr-text")}>Text to QR</Menu.Item>
      </Menu.SubMenu>
      <Menu.Item onClick={()=> navigate('/blogs')}>Blogs</Menu.Item>
    </>
  );

  return (
    <Header className="header">
      <Row justify="space-between" align="middle">
        <Col style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            className="logo"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <img src={require("../../assets/logo.png")} alt="logo" />
          </div>
        </Col>

        {isMobile ? (
          <>
            <Col>
              <Button
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
              />
            </Col>
            <Drawer
              title="Menu"
              placement="right"
              onClose={() => setDrawerVisible(false)}
              open={drawerVisible}
            >
              <Menu mode="inline" selectable={false}>
                {menuItems.props.children}
                <Menu.Item onClick={() => navigate("/login")}>Login</Menu.Item>
                <Menu.Item onClick={() => navigate("/register")}>
                  Sign Up
                </Menu.Item>
              </Menu>
            </Drawer>
          </>
        ) : (
          <>
            <Col flex={1}>
          
              <Menu mode="horizontal" className="menu">
                {menuItems.props.children}
              </Menu>
          
            </Col>
            <Col>
              <Space>
                <Button
                  style={{ width: 100 }}
                  size="large"
                  type="primary"
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
                <Button
                  style={{ width: 100 }}
                  size="large"
                  type="primary"
                  onClick={() => navigate("/register")}
                >
                  Sign Up
                </Button>
              </Space>
            </Col>
          </>
        )}
      </Row>
    </Header>
  );
};

export default HeaderLayout;
